import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventShowSimilarPropertiesPremultileadModal = (clickText: InquiryButtonTypeName | string, propertiesCount: number) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_preMultilead",
        event_action: "view",
        event_label: clickText,
        custom_label: propertiesCount.toString()
    };
    hitGoogleTagManager(gtmData);
};

export const gtmEventSubmitSimilarPropertiesPremultileadModal = (
    clickText: InquiryButtonTypeName | string,
    chosenProperties: number,
    allPropertiesCount: number
) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_preMultilead",
        event_action: "click",
        event_label: clickText,
        custom_label: `${chosenProperties} z ${allPropertiesCount}`
    };
    hitGoogleTagManager(gtmData);
};
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventShowSimilarPropertiesPremultileadModal = (clickText: InquiryButtonTypeName | string, propertiesCount: number) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_preMultilead",
        event_action: "view",
        event_label: clickText,
        custom_label: propertiesCount.toString()
    };
    hitGoogleTagManager(gtmData);
};

export const gtmEventSubmitSimilarPropertiesPremultileadModal = (
    clickText: InquiryButtonTypeName | string,
    chosenProperties: number,
    allPropertiesCount: number
) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_preMultilead",
        event_action: "click",
        event_label: clickText,
        custom_label: `${chosenProperties} z ${allPropertiesCount}`
    };
    hitGoogleTagManager(gtmData);
};
